<template>
  <div class="container pb-4 mb-4">
    <div class="row justify-content-center">
      <div class="col">

        <div v-if="!userInfo.business_address">
          <div class="card mt-4">
            <div class="card-body text-center pb-4">
              <div class="row">
                <div class="col"><h5>Sell on Supalytic</h5></div>
              </div>
              <div class="row">
                <div class="col">First we'll need your collection address</div>
              </div>
              <div class="row">
                <div class="col pt-3">
                  <button
                    type="button"
                    class="btn btn-success px-3"
                    @click="showModalShippingAddress()">Set collection address</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="!userInfo.bank_name || !userInfo.bank_account_name || !userInfo.bank_account_number || !userInfo.bank_branch_code">
          <div class="card">
            <div class="card-body text-center">
              <div><i class="fa-solid fa-circle-check credit mr-2"></i><a href="#/" class="blue2" @click="showModalShippingAddress()">Collection address</a></div>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-body text-center pb-4">
              <div class="row">
                <div class="col"><h5>Sell on Supalytic</h5></div>
              </div>
              <div class="row">
                <div class="col">To get paid, we'll need your banking details</div>
              </div>
              <div class="row">
                <div class="col pt-3">
                  <button
                    type="button"
                    class="btn btn-success px-3"
                    @click="showEditBanking()">Set banking details</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="products == 0">
          <div class="card">
            <div class="card-body text-center">
              <div><i class="fa-solid fa-circle-check credit mr-2"></i><a href="#/" class="blue2" @click="showModalShippingAddress()">Collection address</a></div>
              <div class="mt-2"><i class="fa-solid fa-circle-check credit mr-2"></i><a href="#/" class="blue2" @click="showEditBanking()">Banking details</a></div>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-body text-center pb-4">
              <div class="row">
                <div class="col"><h5>Sell on Supalytic</h5></div>
              </div>
              <div class="row">
                <div class="col">Let's add your first product</div>
              </div>
              <div class="row">
                <div class="col pt-3">
                  <a class="btn btn-success px-4" href="/products/new">Add a product</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="row">
            <div class="col"><h5>Products</h5></div>
            <div class="col text-right pt-1">
              <i v-if="creating" class="fas fa-spinner fa-spin fa-1x"></i>
              <i class="fas fa-plus-circle mr-2"></i
              ><a href="/products/new">Add new product</a>
            </div>
          </div>

          <b-card no-body>
            <b-tabs v-model="tabIndex" card align="center">
              <b-tab title="Approved" title-link-class="darklink">
                <b-card-text>
                  <admin-products-list
                    :status="1"
                    page="Approved"
                  ></admin-products-list>
                </b-card-text>
              </b-tab>
              <b-tab title="In Review" title-link-class="darklink">
                <b-card-text>
                  <admin-products-list
                    :status="2"
                    page="InReview"
                  ></admin-products-list>
                </b-card-text>
              </b-tab>
              <b-tab title="Rejected" title-link-class="darklink">
                <b-card-text>
                  <admin-products-list
                    :status="3"
                    page="Rejected"
                  ></admin-products-list>
                </b-card-text>
              </b-tab>
              <b-tab title="Inactive" title-link-class="darklink">
                <b-card-text>
                  <admin-products-list
                    :status="4"
                    page="Inactive"
                  ></admin-products-list>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
    <shipping-address-modal></shipping-address-modal>
    <edit-banking :user="userInfo"></edit-banking>
  </div>
</template> 

<script>
import { EventBus } from "../bus";

export default {
  props: ['user', 'products', 'tab'],

  data() {
    return {
      tabIndex: 0,
      creating: false,
      userInfo: {},
    };
  },

  created() {
    this.userInfo = this.user;

    EventBus.$on('update-address', () => {
      this.updateUser();
    });

    EventBus.$on('banking-updated', () => {
      this.updateUser();
    });

    if (this.tab == "review") {
      this.tabIndex = 1;
    }
  },

  methods: {
    updateUser() {
      axios.get(`/profile/get`).then((response) => {
        this.userInfo = response.data;
      });
    },

    showEditBanking() {
      this.$bvModal.show(`bv-modal-edit-banking`);
    },

    showModalShippingAddress() {
      this.$bvModal.show(`bv-modal-shipping-address`);
    },
  },
};
</script>